const priorityConstants = {
  CRITICAL_PRIORITY_ID: 1,
  HIGH_PRIORITY_ID: 2,
  MED_PRIORITY_ID: 3,
  LOW_PRIORITY_ID: 4,
};

const commentFlagConstants = {
  ACCEPTED_COMMENT_FLAG_ID: 1,
  REJECTED_COMMENT_FLAG_ID: 2,
  NEUTRAL_COMMENT_FLAG_ID: 3,
};

const qcStatusConstants = {
  QC_PASS_ID: 1,
  QC_FAIL_ID: 2,
  QC_IMPLEMENTED_ID: 3,
  QC_REJECTED_ID: 4,
};

const worklistStatusConstants = {
  OPEN_WORKLIST_STATUS_ID: 1,
  IN_PROGRESS_STATUS_ID: 2,
  CLOSED_STATUS_ID: 3,
  OPEN_STATUS: "Open",
  IN_PROGRESS_STATUS: "In Progress",
  CLOSED_STATUS: "Closed",
};

const worklistStatusIdConstants = {
  OPEN_STATUS_ID: 1,
  IN_PROGRESS_STATUS_ID: 2,
  CLOSED_STATUS_ID: 3,
};

const chartHeaderIds = {
  Location: "Location",
  Client: "Client",
  Specialty: "Specialty",
  chart_no: "Chart No.",
  DateOfService: "Date of Service",
  original_coder: "Original Coder",
  follow_up_coder: "Follow up Coder",
  original_auditor: "Original Auditor",
  Status: "Chart Status",
  Milestone: "Milestone",
  qc_status: "QC status",
  UserId: "Allocated User",
  follow_up_auditor: "Follow Up Auditor",
  Process: "Process",
  ReceivedDate: "Received Date",
  SubSpecialty: "Sub Specialty",
  date_of_coder_allocation: "Date of Coder Allocation",
  date_of_auditor_allocation: "Date of Auditor Allocation",
};

const filterConstants = {
  Milestone: "milestones",
  QCStatus: "qcStatus",
  ChartStatus: "chartStatus",
  DateOfService: "dateOfService",
  ReceivedDate: "receivedDate",
};

const chartStatusConstants = {
  OPEN_STATUS_ID: 1,
  COMPLETE_STATUS_ID: 2,
  INCOMPLETE_STATUS_ID: 3,
};

const dateConstants = {
  TODAY: "today",
  NOT_TODAY: "not_today",
  LAST_WEEK: "last_week",
  LAST_MONTH: "last_month",
};

const userRole = {
  Manager: "Manager",
  TL: "Team Lead",
  Coder: "Coder",
  Auditor: "Auditor",
};

const QAType = {
  QA: 2,
  SENIOR_QA: 11,
};

const milestoneConstants = {
  READY_TO_ALLOCATE_MILESTONE_ID: 1,
  READY_TO_CODE_MILESTONE_ID: 2,
  CODING_IN_PROGRESS_MILESTONE_ID: 3,
  CODING_DONE_MILESTONE_ID: 4,
  READY_TO_AUDIT_MILESTONE_ID: 5,
  AUDIT_IN_PROGRESS_MILESTONE_ID: 6,
  AUDIT_DONE_MILESTONE_ID: 7,
};

const userRoleConstants = {
  MANAGER_ID: 1,
  TEAM_LEAD_ID: 2,
  CODER_ID: 3,
  AUDITOR_ID: 4,
};

const notificationPreferencesMapper = {
  chartAllocation: 'Chart Allocation',
  newCommentInConversationLog: 'New Comment in Conversation Log',
  qcStatusChange: 'QC Status Change',
  prioritizationConditionsChange: 'Prioritization Conditions Change',
  requestedReportUpdate: 'Requested Report Update',
};


module.exports = {
  worklistStatusIdConstants,
  worklistStatusConstants,
  priorityConstants,
  commentFlagConstants,
  qcStatusConstants,
  chartHeaderIds,
  filterConstants,
  chartStatusConstants,
  dateConstants,
  milestoneConstants,
  userRoleConstants,
  userRole,
  QAType,
  notificationPreferencesMapper,
};
